<div class="container-fluid">
    
  <div class="header">
    <mat-form-field appearance="fill" class="select">
        <mat-label>Dispositivo</mat-label>
        <mat-select [(value)]="selectedDisp" [(ngModel)]="selectOpcionDisp" (ngModelChange)="onOptionDisp()">
          <mat-option [value]="option.value" *ngFor="let option of opcionesDisp">{{ option.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>  

      <!-- <div class="spacer1"></div> -->



        <div class="spacer2"></div>
        <button class="buttonRegistroAlarmas" mat-raised-button  (click)="registroAlarmas()">Registro Alarmas</button> 
        <button class="buttonActualizar" mat-raised-button  (click)="actualizar()">Actualizar</button> 
      </div>

    <mat-accordion ding id = "basebacklayer"
    [multi]="true"
    #accordion="matAccordion"
    >
      <mat-expansion-panel 
      [disabled]="panel.isDisabled"
      [expanded]="panel.isExpanded"
      [hideToggle]="true"
      (opened)="beforePanelOpened(panel)"
      (closed)="beforePanelClosed(panel)"
      (afterCollapse)="afterPanelClosed($event)"
      (afterExpand)="afterPanelOpened($event)"
    
      *ngFor="let panel of alarmList"
      #mapanel="matExpansionPanel"
      >
      <mat-expansion-panel-header>
        <mat-panel-title>

            <div class="container-fluid">
              <div class="row align-items-start">
                  <div class="col-9"> 
                      <h4><mat-icon class="carta">alarm_on </mat-icon> {{panel.horaIni}} - {{panel.horaFin}}</h4>
                  </div>  
                  <div class="col-3">
                    <!-- <img *ngIf="(panel.estado)"  class="estadoSrc" src="./../../../assets/imagenes/iconos/activado.png" alt="activado"> -->
                    <mat-icon *ngIf="(panel.estado)" color="#689F38">check_circle_outline </mat-icon>
                    <mat-icon *ngIf="(!panel.estado)" color="##D32F2F">cancel </mat-icon>
                    <!-- <img *ngIf="(!panel.estado)" class="estadoSrc" src="./../../../assets/imagenes/iconos/desactivado.png" alt="desactivado"> -->

                  </div>
                  <div class="w-100"></div>
                  <div>
                      <p> La Alarma sonará {{panel.tipo}} entre las {{panel.horaIni}} - {{panel.horaFin}} </p>
                  </div>
              </div>      
            </div>
                
        </mat-panel-title>
      </mat-expansion-panel-header>


        <!-- <div class="timepicker">
        <mat-form-field appearance="fill" class="select">
            <mat-label>Dispositivo</mat-label>
            <mat-select [(value)]="selectedDisp" [(ngModel)]="selectOpcion" (ngModelChange)="onOptionDisp()">
              <mat-option [value]="option.value" *ngFor="let option of opcionesDisp">{{ option.viewValue }}</mat-option>
            </mat-select>
          </mat-form-field>        
        </div> -->
        <div class="timepicker">
            <mat-form-field appearance="fill" class="select">
                <mat-label>Evento</mat-label>
                <mat-select [(value)]="this.addTipo"[(ngModel)]="this.addTipo" (ngModelChange)="OnOptionEvent()">
                <div *ngIf="(DispActiv1)">
                  <mat-option [value]="option.value"  *ngFor="let option of opcionesEventCama">{{ option.viewValue }}</mat-option>
                </div>
                <div *ngIf="(DispActiv2)">
                  <mat-option [value]="option.value"  *ngFor="let option of opcionesEventSillon">{{ option.viewValue }}</mat-option>
                </div>
                <div *ngIf="(DispActiv3)">
                  <mat-option [value]="option.value"  *ngFor="let option of opcionesEventFridge">{{ option.viewValue }}</mat-option>
                </div>
                </mat-select>
            </mat-form-field>
            </div>

           <!-- NUEVO -->
          <div class="timepicker">
            <mat-form-field class="mat-timepiker">
              <mat-label>Hora Inicio</mat-label>
              <div>
                <input
                  matInput
                  placeholder=" Hora inicio"
                  aria-label="Append to input"
                  [ngxTimepicker]="horaInicial"
                  [format]="24"
                  [value]="panel.horaIni"
                  readonly
                />
                <ngx-material-timepicker-toggle [for]="horaInicial"></ngx-material-timepicker-toggle>
                <ngx-material-timepicker #horaInicial  (timeSet)="onTimeIni($event, panel)"></ngx-material-timepicker>
              </div>
            </mat-form-field>
          </div>  
          <!--  -->


          <!-- <div class="timepicker">
            <mat-form-field>
                <mat-label>Hora Inicio</mat-label>
                <input
                      matInput
                      placeholder=" Hora inicio"
                      aria-label="Append to input"
                      [ngxTimepicker]="horaInicial"
                      [format]="24"
                      [value]="panel.horaIni"
                />
                <mat-icon matSuffix  (click)="horaInicial.open()">watch_later</mat-icon>
                    <ngx-material-timepicker #horaInicial [appendToInput]="true" (timeSet)="onTimeIni($event, panel)">
                    </ngx-material-timepicker>
            </mat-form-field>
        </div> -->
        <div class="timepicker">
          <mat-form-field class="mat-timepiker">    
            <mat-label>Hora final</mat-label>
              <div>
                <input
                  matInput
                  placeholder=" Hora final"
                  aria-label="Append to input"
                  [ngxTimepicker]="horaFinal"
                  [format]="24"
                  [value]="panel.horaFin"
                  readonly
                />
                <!-- <mat-icon matSuffix  (click)="horaFinal.open()"> watch_later</mat-icon> -->
                <ngx-material-timepicker-toggle [for]="horaFinal"></ngx-material-timepicker-toggle>
                <ngx-material-timepicker #horaFinal (timeSet)="onTimeFin($event, panel)"></ngx-material-timepicker>
              </div>
            </mat-form-field>
        </div>
        
        <mat-slide-toggle class="mat-toggle" [(ngModel)]="panel.estado">Estado de la alarma</mat-slide-toggle> 

        <mat-action-row>
            <button color="success" mat-flat-button (click)="saveAlarm(panel, option)">Guardar</button>
            <button color="success" mat-flat-button (click)="mapanel.close()">Cerrar Ventana</button>
            <button color="danger"  mat-flat-button  (click)="deleteAlarm(panel)">Eliminar</button>
        </mat-action-row>
      </mat-expansion-panel>

    </mat-accordion>
    
    <!-- color="$accent-color-2" -->
        <div class="button-container">
          <button class="buttonActualizar" mat-raised-button (click)="addAlarm()">
            <mat-icon>alarm_add</mat-icon>
        </button>
        <div>



</div>


